import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { NgxPermissionsService } from 'ngx-permissions';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { CommonDataService } from '../core/services/common-data.service';

@Injectable()
export class LandingResolver implements Resolve<Observable<object>> {
    constructor(private _dataService: CommonDataService,
        private _permissionService: NgxPermissionsService) { }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        return this._dataService.getUserDetails().pipe(tap(response => {
            if (response.success) {
                const roles = [];
                const result = response.data;
                console.log('Roles   :' + result.Role);
                roles.push(result.Role);
                this._permissionService.loadPermissions(roles);
            }
        }));
    }
}